import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
// import 'typeface-roboto';
import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import { StepButtons, MobileCustom, CurrencyCustom, ZipCustom, HomeAreaCode, HomeTelCustom2 } from "../CommonComponents";
import { Consumer } from "./EWCCContext";
import styles from "../ewccstyle";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import FormHelperText from "@material-ui/core/FormHelperText";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const SpouseInfromation = withStyles(styles)(function(props) {
  const { activeStep, handleBack, classes } = props;
  return (
    <Consumer>
      {context => (
        <Formik
          initialValues={{
            spouseName: context.spouseName,
            spouseBusiness: context.spouseBusiness,
            spousePosition: context.spousePosition,
            spouseDept: context.spouseDept,
            spouseAddress: context.spouseAddress,
            spouseZip: context.spouseZip,
            spousePhone: context.spousePhone,
            spouseAreaCode: context.spouseAreaCode,
            spouseCP: context.spouseCP,
            spouseIncome: context.spouseIncome
          }}
          validationSchema={Yup.object().shape({
            spouseName: Yup.string().max(200,"Text too long"),
            spouseBusiness: Yup.string().max(200,"Text too long"),
            spousePosition: Yup.string().max(2000,"Text too long"),
            spouseDept: Yup.string().max(200,"Text too long"),
            spousePhone: Yup.string()
                .matches(/\d\d\d-\d\d\d\d/, "Invalid Number")
                .when("homeAreaCode", {
                  is: spouseAreaCode => spouseAreaCode != undefined,
                  then: Yup.string().required("Home Phone Number is required")
                }),

            spouseAreaCode: Yup.string()
              .matches(/\d\d/, "Invalid Area Code")
              .when("homePhone", {
                is: spousePhone => spousePhone != undefined,
                then: Yup.string().required("Area Code is required")
            }),

            spouseCP: Yup.string().matches(
              /\(\d\d\)\s\d\d\d-\d\d\d-\d\d\d\d/,
              "Invalid Mobile Phone Number"
            ),
            spouseIncome: Yup.string().max(20,
              "Invalid Amount"
            ),
            
          },
          [["homePhone", "homeAreaCode"]]
          )}
          onSubmit={(values, actions) => {
            context.updateState("spouseName", values.spouseName);
            context.updateState("spouseBusiness", values.spouseBusiness);
            context.updateState("spousePosition", values.spousePosition);
            context.updateState("spouseDept", values.spouseDept);
            context.updateState("spouseAddress", values.spouseAddress);
            context.updateState("spouseZip", values.spouseZip);
            context.updateState("spousePhone", values.spousePhone);
            context.updateState("spouseAreaCode", values.spouseAreaCode);
            context.updateState("spouseCP", values.spouseCP);
            context.updateState("spouseIncome", values.spouseIncome);
            actions.setSubmitting(false);
            props.handleSubmit();
          }}
        >
          {props => {
            const {
              values,
              errors,
              touched,

              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            } = props;
            return (
              <form noValidate autoComplete="off">
                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseName"
                    label="Name of Spouse"
                    className={classes.textField}
                    value={values.spouseName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ minWidth: 300 }}
                    helperText={
                      errors.spouseName && touched.spouseName
                        ? errors.spouseName
                        : "(First, Middle, Last)"
                    }
                    error={
                      errors.spouseName && touched.spouseName ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseBusiness"
                    label="Company/Business Name"
                    className={classes.textField}
                    value={values.spouseBusiness}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.spouseBusiness && touched.spouseBusiness
                        ? errors.spouseBusiness
                        : ""
                    }
                    error={
                      errors.spouseBusiness && touched.spouseBusiness ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spousePosition"
                    label="Position"
                    className={classes.textField}
                    value={values.spousePosition}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.spousePosition && touched.spousePosition
                        ? errors.spousePosition
                        : ""
                    }
                    error={
                      errors.spousePosition && touched.spousePosition ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseDept"
                    label="Department"
                    className={classes.textField}
                    value={values.spouseDept}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.spouseDept && touched.spouseDept
                        ? errors.spouseDept
                        : ""
                    }
                    error={
                      errors.spouseDept && touched.spouseDept ? true : false
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseAddress"
                    label="Company/Business Address"
                    className={classes.textField}
                    value={values.spouseAddress}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                      errors.spouseAddress && touched.spouseAddress
                        ? errors.spouseAddress
                        : "Limit input to 120 characters including spaces"
                    }
                  />
                </FormControl>

                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseZip"
                    label="Zip Code"
                    className={classes.textField}
                    value={values.spouseZip}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                      inputComponent: ZipCustom
                    }}
                    helperText={
                      errors.spouseZip && touched.spouseZip
                        ? errors.spouseZip
                        : ""
                    }
                    error={errors.spouseZip && touched.spouseZip ? true : false}
                  />
                </FormControl>

                <Grid container className={classes.homeNumber}>
                  <FormControl
                    margin="dense"
                    error={errors.spouseAreaCode ? true : false}
                  >
                    <InputLabel htmlFor="spouseAreaCode ">Area Code</InputLabel>
                    <Input
                      id="spouseAreaCode"
                      value={values.spouseAreaCode}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.spouseAreaCode && touched.spouseAreaCode
                          ? true
                          : false
                      }
                      inputComponent={HomeAreaCode}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error
                      }}
                      component="p"
                    >
                      {errors.spouseAreaCode ||
                        (touched.spouseAreaCode && <>{errors.spouseAreaCode}</>)}
                        
                    </FormHelperText>
                  </FormControl>

                  <FormControl
                    margin="dense"
                    error={errors.spousePhone ? true : false}
                  >
                    <InputLabel htmlFor="spousePhone">
                      Company/Business Phone Number 
                    </InputLabel>
                    <Input
                      id="spousePhone"
                      value={values.spousePhone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={
                        errors.spousePhone && touched.spousePhone ? true : false
                      }
                      inputComponent={HomeTelCustom2}
                    />
                    <FormHelperText
                      margin="dense"
                      classes={{
                        root: classes.dropdownError,
                        error: classes.error
                      }}
                      component="p"
                    >
                      {errors.spousePhone ||
                        (touched.spousePhone && <>{errors.spousePhone}</>)}
                    </FormHelperText>
                  </FormControl>
        
                </Grid>

                <FormControl
                  margin="dense"
                >
                  <Typography variant="caption" style={{color: 'rgba(0, 0, 0, 0.54)', marginTop: '-10px'}}>Include local/extension and if provincial, area code </Typography>
                </FormControl> 

                <FormControl
                  fullWidth
                  margin="dense"
                  error={errors.spouseCP && touched.spouseCP ? true : false}
                >
                  <InputLabel htmlFor="spouseCP">
                    Mobile Phone Number
                  </InputLabel>
                  <Input
                    id="spouseCP"
                    value={values.spouseCP}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={errors.spouseCP && touched.spouseCP ? true : false}
                    inputComponent={MobileCustom}
                  />
                  <FormHelperText
                    argin="dense"
                    classes={{
                      root: classes.dropdownError,
                      error: classes.error
                    }}
                    component="p"
                  >
                    {errors.spouseCP && touched.spouseCP && (
                      <>{errors.spouseCP}</>
                    )}
                  </FormHelperText>
                </FormControl>


                <FormControl fullWidth margin="dense">
                  <TextField
                    id="spouseIncome"
                    label="Gross Annual Income"
                    value={values.spouseIncome}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    helperText={
                       touched.spouseIncome
                        ? errors.spouseIncome
                        : "Should match income document submitted"
                    }
                    error={
                      errors.spouseIncome && touched.spouseIncome
                        ? true
                        : false
                    }
                    InputProps={{
                      inputComponent: CurrencyCustom
                    }}
                  />
                </FormControl>
                <StepButtons
                  isSubmitting={isSubmitting}
                  activestep={activeStep}
                  handleBack={handleBack}
                  handleNext={handleSubmit}
                />
              </form>
            );
          }}
        </Formik>
      )}
    </Consumer>
  );
});

export default SpouseInfromation;
